import type { IconNode } from '../types';

/**
 * @name flippers
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjAgMTdjMC00IDItNyAyLTEzLjUgMC0uMy0uMi0uNS0uNS0uNUMxOSAzIDE3IDQgMTcgNHMtMi0xLTQuNS0xaC0xQzkgMyA3IDQgNyA0UzUgMyAyLjUgM2MtLjMgMC0uNS4yLS41LjVDMiAxMCA0IDEzIDQgMTciIC8+CiAgPHBhdGggZD0iTTEyIDN2LjVDMTIgMTAgMTAgMTMgMTAgMTciIC8+CiAgPHJlY3Qgd2lkdGg9IjYiIGhlaWdodD0iNyIgeD0iNCIgeT0iMTQiIHJ4PSIzIiAvPgogIDxwYXRoIGQ9Ik0xMiAzLjVDMTIgMTAgMTQgMTMgMTQgMTciIC8+CiAgPHJlY3Qgd2lkdGg9IjYiIGhlaWdodD0iNyIgeD0iMTQiIHk9IjE0IiByeD0iMyIgLz4KICA8cGF0aCBkPSJNNyA0djYiIC8+CiAgPHBhdGggZD0iTTE3IDR2NiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/flippers
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const flippers: IconNode = [
  [
    'path',
    {
      d: 'M20 17c0-4 2-7 2-13.5 0-.3-.2-.5-.5-.5C19 3 17 4 17 4s-2-1-4.5-1h-1C9 3 7 4 7 4S5 3 2.5 3c-.3 0-.5.2-.5.5C2 10 4 13 4 17',
      key: 'qalp38',
    },
  ],
  ['path', { d: 'M12 3v.5C12 10 10 13 10 17', key: '1i2zo3' }],
  ['rect', { width: '6', height: '7', x: '4', y: '14', rx: '3', key: '5r0l9e' }],
  ['path', { d: 'M12 3.5C12 10 14 13 14 17', key: '18svt2' }],
  ['rect', { width: '6', height: '7', x: '14', y: '14', rx: '3', key: '11vnj7' }],
  ['path', { d: 'M7 4v6', key: 'qh2wlw' }],
  ['path', { d: 'M17 4v6', key: 'a2g0hx' }],
];

export default flippers;
